
// Angular
import { Component, OnInit, Input, OnChanges } from '@angular/core';

import intersection from "lodash-es/intersection";
import pick from "lodash-es/pick";

// Afidium
import { ICost } from 'libraries/service/resources/model/search/IBooking';
import { HotelCurrencyService } from 'libraries/service/hotel-currency/hotel-currency.service';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { ICurrencies } from 'libraries/service/resources/hotel/ISearchResponse';
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';
import { ConfigSharedHotelService } from 'libraries/service/resources/configuration/config-shared-hotel.service';
import {
    GetMainCurrencyService,
    ICurrencyConfig, IMainAndAsidePrices,
    IPrice
} from "../../../service/get-main-currency/get-main-currency.service";

@Component({
    selector: 'price-details',
    template: `
        <ng-container class="price-details" *ngIf="cost && mainPrice">
            <div class="priceMainDetails"
                [innerHTML]="mainPrice.amount| priceRealAmount: mainPrice.currency"></div>
            <div *ngIf="asidePrice" class="priceAsideDetails">
                <em [innerHTML]="asidePrice.amount | priceRealAmount: asidePrice.currency"></em>
            </div>
        </ng-container>
    `,
    styles: [`
        .price-details{
            text-align: right;
        }
        .priceMainDetails{
            font-size: 1.1em;
            font-weight: bold;
        }
        .priceAsideDetails{
            color: #666;
            font-size: 0.6em;
        }

        ::ng-deep span.symbol {
            font-size: .8em;
        }

        .priceAsideDetails ::ng-deep span.symbol {
            font-size: 0.7em;
        }
    `]
})

export class PriceDetailsComponent implements OnInit, OnChanges  {

    //////////////////////////////////// COMPONENT VARIABLES& ////////////////////////////////////

    @Input()
    public cost: ICost;

    @Input()
    public currencies: ICurrencies;

    public mainPrice: IPrice;
    public asidePrice: IPrice;

    private sharedHotelConfig: IConfigSharedHotel;

    //////////////////////////////////// CONSTRUCTOR ////////////////////////////////////

    constructor(
        private hotelCurrencyService: HotelCurrencyService,
        private quotationService: QuotationService,
        private configSharedHotelService: ConfigSharedHotelService,
        private getMainCurrencyService: GetMainCurrencyService
    ){}

    //////////////////////////////////// COMPONENT LIFECYCLE HOOKS ////////////////////////////////////

    public ngOnInit(): void {
        this.configSharedHotelService.getConfiguration()
            .subscribe({
                next: (sharedHotelConfig: IConfigSharedHotel) : void => {
                    this.sharedHotelConfig = sharedHotelConfig;
                    this.computePrices();
                }
            });
    }

    public ngOnChanges(): void {
        this.computePrices();
    }

    //////////////////////////////////// COMPONENT METHODS ////////////////////////////////////

    private computePrices(): void {
        if (!this.currencies || !this.sharedHotelConfig){
            this.mainPrice = null;
            this.asidePrice = null;
            return;
        }

        const config: ICurrencyConfig = this.getMainCurrencyService.getCurrencyConfig(this.cost, this.currencies, this.sharedHotelConfig);

        const prices: IMainAndAsidePrices = this.getMainCurrencyService.getMainAndAsidePrice(this.cost, this.currencies, config);

        this.mainPrice = prices.mainPrice;
        this.asidePrice = prices.asidePrice;
    }
}